import {
  FETCH_LEADS_EXPORTS_START,
  FETCH_LEADS_EXPORTS_SUCCESS,
  FETCH_LEADS_EXPORTS_FAILURE,
  CREATE_LEADS_EXPORT_START,
  CREATE_LEADS_EXPORT_SUCCESS,
  CREATE_LEADS_EXPORT_FAILURE,
  RESET_LEADS_EXPORT_CREATE,
  LEADS_EXPORT_UPDATED,
} from '../constants/leadsExportsTypes'

const INITIAL = {
  list: { loading: false, success: null, data: [], errors: null },
  create: { loading: false, success: null, data: null, errors: null },
}

export default function reducer(state = INITIAL, action) {
  switch (action.type) {
    case FETCH_LEADS_EXPORTS_START:
      return {
        ...state,
        list: { loading: true, success: null, data: state.list.data, errors: null },
      }
    case FETCH_LEADS_EXPORTS_SUCCESS:
      return {
        ...state,
        list: { loading: false, success: true, data: action.data || [], errors: null },
      }
    case FETCH_LEADS_EXPORTS_FAILURE:
      return {
        ...state,
        list: { loading: false, success: false, data: state.list.data, errors: action.errors },
      }

    case CREATE_LEADS_EXPORT_START:
      return {
        ...state,
        create: { loading: true, success: null, data: null, errors: null },
      }
    case CREATE_LEADS_EXPORT_SUCCESS:
      return {
        ...state,
        create: { loading: false, success: true, data: action.data, errors: null },
        list: { ...state.list, data: [action.data, ...state.list.data] },
      }
    case CREATE_LEADS_EXPORT_FAILURE:
      return {
        ...state,
        create: { loading: false, success: false, data: null, errors: action.errors },
      }
    case RESET_LEADS_EXPORT_CREATE:
      return { ...state, create: INITIAL.create }

    case LEADS_EXPORT_UPDATED: {
      const payload = action.result
      if (!payload || state.list.data.findIndex(r => r.id === payload.id) === -1) {
        return state
      }
      return {
        ...state,
        list: {
          ...state.list,
          data: state.list.data.map(r => (r.id === payload.id ? { ...r, ...payload } : r)),
        },
      }
    }

    default:
      return state
  }
}
